// Turns a folder-picker FileList into a candidateNumber → File lookup.
// Files are matched purely by base filename: "<candidateNumber>.<ext>".
// Session-only, client-side — nothing here touches the network or storage.

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'webp']);

export interface CandidateImageResult {
  map: Map<number, File>;
  skipped: number;
}

export function buildCandidateImageMap(files: File[]): CandidateImageResult {
  const map = new Map<number, File>();
  let skipped = 0;
  for (const file of files) {
    const dot = file.name.lastIndexOf('.');
    const ext = dot >= 0 ? file.name.slice(dot + 1).toLowerCase() : '';
    const base = dot >= 0 ? file.name.slice(0, dot) : file.name;
    if (!IMAGE_EXTENSIONS.has(ext) || !/^\d+$/.test(base)) {
      skipped++;
      continue;
    }
    const num = parseInt(base, 10);
    if (map.has(num)) {
      skipped++;
      continue;
    }
    map.set(num, file);
  }
  return { map, skipped };
}
